module.exports = __webpack_public_path__ + "img/19.a51530b0.png";